<template>
    <div class="form-small">
        <div class="text-center logo-login">
            <img src="../../images/home/nextempleamar-logo.png" width="197" alt="NextempeleaMar" />
        </div>
        <div class="txt-intro mt-2 ">{{__('Registro de usuario')}}</div>

        <form @submit.prevent="handleSubmit" class="card-body">
            <input-float :title="__('name')" v-model="form.name" name="name" required />
            <input-float :title="__('surnames')" name="surnames" v-model="form.surnames" required />
            <input-float title="NIF" :validationFunction="validNIFNIE" v-model="form.nif" :errorMsg="__('NIF no válido')" required />
            <input-float :title="__('email')" type="email" v-model="form.email" required />
            <!-- <toggle-label :title="__('request_validation')" v-model="form.request_validation" /> -->
            <div class="form-group mb-0">
                <btn block type="submit">{{__('submit')}}</btn>
            </div>
        </form>
        <div class="text-center mt-2">
          <strong><inertia-link class="form-link" href="/login" preserve-scroll>{{ __('return_to_login') }}</inertia-link></strong>
        </div>
    </div>
</template>

<script>

import { Inertia } from "@inertiajs/inertia";

export default
{
    name: "Register",
    data() {
        return {
            password_repeat: "",
            form: {

            }
        }
    },
    methods: {
        handleSubmit( e ) {
            this.$inertia.post( "/register", this.form )
        },
    
        validNIFNIE( nif ) {
            nif = nif.toUpperCase();
            var dni = nif.substring( 0, 8 );
            //los nie empiezan por X, que para el calculo se convierten en cero:
            if ( dni.substring( 0, 1 ) == "X" ) dni = dni.replace( "X", 0 );
            else if ( dni.substring( 0, 1 ) == "Y" ) dni = dni.replace( "Y", 1 );
            else if ( dni.substring( 0, 1 ) == "Z" ) dni = dni.replace( "Z", 2 );
            else {
                if ( dni.substring( 0, 1 ) == "T" && /^[T]{1}[A-Z0-9]{8}$/.test( nif ) ) return true;
            }

            if ( !/^\d{8}$/.test( dni ) || nif.length > 9 ) {
                return false;
            }
            var letra = nif.substring( 8, 9 ).toUpperCase();
            var letras = 'TRWAGMYFPDXBNJZSQVHLCKE';
            var numero = dni % 23;
            if ( letra != letras.substring( numero, numero + 1 ) ) {
                return false;
            }
            

            return true;
        },
    }
}
</script>
